var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import RegularRate from '../rates/RegularRate';
import { onLongTouch } from '../slots/slotUtils';
import Tappable from 'react-tappable';
import * as SlotFamilyMap from '../../../../constants/SlotFamilyType';
var MatchResultOutcome = /** @class */ (function (_super) {
    __extends(MatchResultOutcome, _super);
    function MatchResultOutcome() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            sectionToggled: _this.props.expanded
        };
        _this.onClick = function () {
            _this.setState({
                sectionToggled: !_this.state.sectionToggled
            });
        };
        _this.onLongTouchClick = function () {
            onLongTouch(_this.props.slot, _this.props.match);
        };
        return _this;
    }
    MatchResultOutcome.prototype.render = function () {
        var _a = this.props, outcome = _a.outcome, gridLocalization = _a.gridLocalization, section = _a.section, slotName = _a.slotName, slotFamily = _a.slotFamily;
        var sectionToggled = this.state.sectionToggled;
        var sectionCls = sectionToggled ? 'section selected' : 'section';
        if (outcome === undefined) {
            return false;
        }
        var rateIds = outcome.get('rates');
        var renderRates = [];
        var props = {
            gridLocalization: gridLocalization,
            section: section
        };
        rateIds.map(function (rateId) {
            renderRates.push(_jsx("div", __assign({ className: 'cols' }, { children: _jsx(RegularRate, __assign({ id: rateId }, props)) }), rateId));
        });
        var itemCls = slotFamily === SlotFamilyMap.MATCH_HANDICAP || slotFamily === SlotFamilyMap.MINIMATCH_TOTAL ? 'item two' : 'item';
        return (_jsxs("div", __assign({ className: sectionCls }, { children: [_jsx(Tappable, __assign({ className: 'title toggle tappable-header', onClick: this.onClick, onPress: this.onLongTouch, stopPropagation: true }, { children: _jsxs("div", __assign({ className: 'name' }, { children: [outcome.get('name'), " ", slotName] })) })), sectionToggled && _jsx("div", __assign({ className: 'items toggle_content' }, { children: _jsx("div", __assign({ className: itemCls }, { children: _jsx("div", __assign({ className: 'rows' }, { children: renderRates })) })) }))] })));
    };
    return MatchResultOutcome;
}(React.Component));
MatchResultOutcome.propTypes = {
    gridLocalization: PropTypes.object.isRequired,
    isFirst: PropTypes.bool.isRequired,
    outcome: PropTypes.object.isRequired,
    section: PropTypes.string.isRequired,
    slotName: PropTypes.string.isRequired,
    slotFamily: PropTypes.number.isRequired,
    expanded: PropTypes.bool.isRequired
};
export default MatchResultOutcome;



// WEBPACK FOOTER //
// ./src/components/grid/event/outcomes/MatchResultOutcome.jsx